module.exports = __webpack_public_path__ + "static/media/sidd_logo6.695d3312.png";